import store from '@/store';
import { api } from '@/utils/api';
import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchHSCodes(ctx, queryParams) {
      console.log('=== HSCodeStoreModule fetchHSCodes():', { queryParams });

      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        console.log('=== HSCodeStoreModule businessID', businessID);

        const params = {
          businessID,
          pageNumber: queryParams.page || 1,
          pageSize: queryParams.perPage || 10,
          searchTerm: queryParams.q || '',
        };

        // Only add isActive filter if it has a valid value (not null or undefined)
        if (queryParams.isActive !== null && queryParams.isActive !== undefined) {
          params.isActive = queryParams.isActive;
        }

        console.log('=== HSCodeStoreModule params', params);

        api
          .get(`/HSCode/GetByPagination/${businessID}`, { params })
          .then((response) => {
            console.log('=== HSCodeStoreModule response', response.data);

            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject('Error fetching HS Codes list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    fetchHSCode(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .get(`/HSCode/LoadSelectedData/${businessID}/${id}`)
          .then((response) => {
            console.log('=== HSCodeStoreModule response', response.data);
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject('Error fetching HS Code data');
            }
          })
          .catch((error) => reject(error));
      });
    },
    addHSCode(ctx, hsCodeData) {
      hsCodeData.businessID = store.state.user.businessID;

      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = hsCodeData.userID || store.state.user.userID;

        if (!userID) {
          reject(new Error('User ID not found. Please login again.'));
          return;
        }

        api
          .post(`/HSCode/Save/${businessID}?userID=${userID}`, hsCodeData)
          .then((response) => {
            console.log(response);
            resolve(response.data.data);
          })
          .catch((error) => reject(error));
      });
    },
    editHSCode(ctx, hsCodeData) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = hsCodeData.userID || store.state.user.userID;

        if (!userID) {
          reject(new Error('User ID not found. Please login again.'));
          return;
        }

        api
          .post(`/HSCode/Save/${businessID}?userID=${userID}`, hsCodeData)
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    deleteHSCode(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID;

        api
          .delete(`/HSCode/Delete/${businessID}/${id}`)
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
